import React, { useEffect } from 'react'
import { useRef } from 'react';
import { Toast, ToastMessage } from 'primereact/toast'
import { useSelector } from 'react-redux/es/hooks/useSelector';

export const toastSuccess: ToastMessage = { severity: 'success', life: 3000 }
export const toastError: ToastMessage = { severity: 'error', life: 3000 }
export const toastInfo: ToastMessage = { severity: 'info', life: 3000 }
export const toastWarn: ToastMessage = { severity: 'warn', life: 3000 }

function MobligoToast() {
    const toast = useRef<Toast>(null);
    const toastSettings = useSelector((state: any) => state.systemSlice.toastSettings);

    useEffect(() => {
        if (toastSettings?.summary && toastSettings?.severity)
            toast?.current?.show(toastSettings);
    }, [toastSettings])
    return (

        <Toast className='z-50 translate-y-[60px]' ref={toast} position="top-right" />

    )
}

export default MobligoToast